module.exports = __webpack_public_path__ + "img/qr-code-scan.b9aa8845.png";